import AppShell from './components/AppShell';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import CustomerEdit from './components/customers/CustomerEdit';
import CustomerInvoiceList from './components/customers/CustomerInvoiceList';
import CustomerProjectList from './components/customers/CustomerProjectList';
import CustomersList from './components/customers/CustomersList';
import InvoiceEditPage from './components/invoices/InvoiceEditPage';
import InvoiceList from './components/invoices/InvoiceList';
import InvoicePreview from './components/invoices/InvoicePreview';
import Products from './components/products/Products';
import NewProject from './components/projects/NewProject';
import ProjectList from './components/projects/ProjectList';
import ViewProject, {ViewProjectTabs} from './components/projects/ViewProject';
import IncomeReport from './components/reports/IncomeReport';
import ReportsShell from './components/reports/ReportsShell';
import SalesReport from './components/reports/SalesReport';
import SalesTaxReport from './components/reports/SalesTaxReport';
import TagManagement from './components/tags/TagManagement';
import TransactionsList from './components/transactions/TransactionsList';
import Trips from './components/trips/Trips';
import {redirect} from 'react-router';
import {createBrowserRouter, useParams} from 'react-router-dom';

export default createBrowserRouter([
	{
		id: 'login',
		path: '/login',
		loader: async () => {
			const response = await fetch('/api/sessions/validate');

			if (response.ok) {
				return redirect('/');
			}

			return null;
		},
		Component: Login,
	},
	{
		id: 'root',
		path: '/',
		loader: async () => {
			const response = await fetch('/api/sessions/validate');

			if (!response.ok) {
				return redirect('/login');
			}

			return null;
		},
		Component: AppShell,
		children: [
			{
				id: 'dashboard',
				index: true,
				Component: Dashboard,
			},
			{
				id: 'projects',
				path: '/projects',
				children: [
					{
						id: 'projects-list',
						index: true,
						Component: ProjectList,
					},
					{
						id: 'new-project',
						path: '/projects/new',
						Component: NewProject,
					},
					{
						id: 'view-project',
						path: '/projects/:projectId/:projectTab?',
						loader: ({params: {projectId, projectTab}}) => {
							if (!projectId) {
								throw new Response('Invalid project', {
									status: 400,
									statusText: 'Bad Request',
								});
							}

							// TODO: Validate project ID and send 404?

							if (!projectTab || !ViewProjectTabs.includes(projectTab)) {
								return redirect(`/projects/${projectId}/${ViewProjectTabs[0]}`);
							}

							return null;
						},
						Component: () => {
							const {projectId, projectTab} = useParams();

							return <ViewProject projectId={projectId!} selectedTab={projectTab!} />;
						},
					},
				],
			},
			{
				id: 'customers',
				path: '/customers',
				children: [
					{
						id: 'customers-list',
						index: true,
						Component: CustomersList,
					},
					{
						id: 'new-customer',
						path: '/customers/new',
						Component: () => {
							return <CustomerEdit customerId={null} />;
						},
					},
					{
						id: 'edit-customer',
						path: '/customers/:customerId/edit',
						Component: () => {
							const {customerId} = useParams();

							return <CustomerEdit customerId={customerId!} />;
						},
					},
					{
						id: 'customer-invoice-list',
						path: '/customers/:customerId/invoices',
						Component: () => {
							const {customerId} = useParams();

							return <CustomerInvoiceList customerId={customerId!} />;
						},
					},
					{
						id: 'customer-project-list',
						path: '/customers/:customerId/projects',
						Component: () => {
							const {customerId} = useParams();

							return <CustomerProjectList customerId={customerId!} />;
						},
					},
				],
			},
			{
				id: 'invoices',
				path: '/invoices',
				children: [
					{
						id: 'invoices-list',
						index: true,
						Component: InvoiceList,
					},
					{
						id: 'update-invoice',
						path: '/invoices/:invoiceId/edit',
						Component: () => {
							const {invoiceId} = useParams();

							return <InvoiceEditPage invoiceId={invoiceId ?? null} />;
						},
					},
					{
						id: 'new-invoice',
						path: '/invoices/new',
						Component: () => {
							return <InvoiceEditPage invoiceId={null} />;
						},
					},
				],
			},
			{
				id: 'transactions',
				path: '/transactions',
				children: [
					{
						id: 'transactions-list',
						index: true,
						Component: TransactionsList,
					},
				],
			},
			{
				id: 'trips',
				path: '/trips',
				children: [
					{
						id: 'trips-index',
						index: true,
						Component: Trips,
					},
				],
			},
			{
				id: 'reports',
				path: '/reports',
				Component: ReportsShell,
				children: [
					{
						id: 'income-report',
						path: '/reports/income',
						Component: IncomeReport,
					},
					{
						id: 'sales-tax-report',
						path: '/reports/sales-tax',
						Component: SalesTaxReport,
					},
					{
						id: 'sales-report',
						path: '/reports/sales',
						Component: SalesReport,
					},
				],
			},
			{
				id: 'products',
				path: '/products',
				Component: Products,
			},
			{
				id: 'tag-management',
				path: '/tags',
				Component: TagManagement,
			},
		],
	},
	{
		id: 'invoice-preview',
		path: '/preview/:invoiceId',
		Component: () => {
			const {invoiceId} = useParams();

			return <InvoicePreview invoiceId={invoiceId!} />;
		},
	},
]);
